import { Box, useTheme } from "@mui/material";
import Header from "./Admin/components/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "./Admin/theme";

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <div
      style={{
        backgroundColor: "#141b2d",
        paddingTop: "15px",
        paddingBottom: "20px",
      }}
    >
      <Box m="20px">
        <div style={{ textAlign: "center" }}>
          <Header subtitle="Frequently Asked Questions " />
        </div>

        <Accordion defaultExpanded backgroundColor={colors.primary[100]}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            style={{ backgroundColor: "#141b2d" }}
          >
            <Typography
              color={colors.greenAccent[500]}
              variant="h5"
              style={{ backgroundColor: "#141b2d" }}
            >
              An Important Question
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{ backgroundColor: "#141b2d", color: "white" }}
          >
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded backgroundColor={colors.primary[100]}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            style={{ backgroundColor: "#141b2d" }}
          >
            <Typography
              color={colors.greenAccent[500]}
              variant="h5"
              style={{ backgroundColor: "#141b2d" }}
            >
              An Important Question
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{ backgroundColor: "#141b2d", color: "white" }}
          >
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded backgroundColor={colors.primary[100]}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            style={{ backgroundColor: "#141b2d" }}
          >
            <Typography
              color={colors.greenAccent[500]}
              variant="h5"
              style={{ backgroundColor: "#141b2d" }}
            >
              An Important Question
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{ backgroundColor: "#141b2d", color: "white" }}
          >
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};

export default FAQ;
